import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-question-answer-line"></i>
            <span>常见问题</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            关于糖心视频的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={`rounded-xl border transition-all duration-300 cursor-pointer ${
                  isOpen
                    ? 'bg-background-50 border-primary-200'
                    : 'bg-background-50 border-background-200 hover:border-background-300'
                }`}
                onClick={() => setOpenId(isOpen ? null : item.id)}
              >
                <div className="flex items-center justify-between gap-4 p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-2">
                    {item.question}
                  </h3>
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                      isOpen
                        ? 'bg-primary-500 text-white rotate-45'
                        : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    <i className="ri-add-line text-sm"></i>
                  </div>
                </div>

                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed border-t border-primary-100/50 pt-4">
                    {item.answer}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}